/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React, { useEffect } from "react";
import { checkToken } from "@/src/services/localStorage";
import { logout } from "@/src/store/login/actions";
import { Navigate, Outlet, useLocation } from "react-router";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import ConsentUpdateModal from "@/src/components/ConsentUpdateModal/ConsentUpdateModal";
import { useQueryClient } from "@tanstack/react-query";

export default function AuthenticatedRoutes() {
  const { customer, isLoading } = useCustomer();
  const location = useLocation();
  const queryClient = useQueryClient();
  const isAuthenticated = checkToken(localStorage.getItem("token"), customer);

  useEffect(() => {
    if (!!customer && !isAuthenticated) {
      logout(queryClient);
    }
  }, [customer, isAuthenticated]);

  if (!customer && isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={"/login"} state={{ from: location }} replace />;
  }

  return (
    <>
      <ConsentUpdateModal />
      <Outlet />
    </>
  );
}
